import { render } from "./MarketBase.vue?vue&type=template&id=19cd21e6"
import script from "./MarketBase.vue?vue&type=script&lang=js"
export * from "./MarketBase.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./MarketBase.vue?vue&type=style&index=0&id=19cd21e6&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__